<nav class="enlaces-legales ion-text-center" aria-label="Documentos legales">
  <a routerLink="/terminos-de-uso">Términos y Condiciones</a>
  <span class="separador" aria-hidden="true">·</span>
  <a routerLink="/politica-de-privacidad">Política de Privacidad</a>
</nav>
